import { useId } from 'react'

export function BrandMark() {
  const id = useId().replaceAll(':', '')
  const ringGradientId = `ark-ring-${id}`
  const wingGradientId = `ark-wing-${id}`
  const wingShadeId = `ark-wing-shade-${id}`
  const bladeGradientId = `ark-blade-${id}`
  const ringShadowId = `ark-ring-shadow-${id}`
  const planeShadowId = `ark-plane-shadow-${id}`

  return (
    <svg
      className="brand-mark"
      viewBox="90 52 232 232"
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id={ringGradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="0.48" stopColor="#f9fafc" />
          <stop offset="1" stopColor="#eef1f5" />
        </linearGradient>
        <linearGradient
          id={wingGradientId}
          x1="138"
          y1="196"
          x2="245"
          y2="138"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#6686a9" />
          <stop offset="0.58" stopColor="#9ab7d3" />
          <stop offset="1" stopColor="#dce8f3" />
        </linearGradient>
        <linearGradient
          id={wingShadeId}
          x1="138"
          y1="196"
          x2="196"
          y2="196"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#284767" stopOpacity="0.5" />
          <stop offset="1" stopColor="#6e8eae" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id={bladeGradientId}
          x1="198"
          y1="183"
          x2="239"
          y2="218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffffff" />
          <stop offset="0.56" stopColor="#f8f9fb" />
          <stop offset="1" stopColor="#e8edf2" />
        </linearGradient>
        <filter
          id={ringShadowId}
          x="-20%"
          y="-20%"
          width="140%"
          height="140%"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.1" result="blur" />
          <feOffset dy="1" result="offset" />
          <feFlood floodColor="#000817" floodOpacity="0.9" result="shadowColor" />
          <feComposite in="shadowColor" in2="offset" operator="in" result="shadow" />
          <feMerge>
            <feMergeNode in="shadow" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <filter
          id={planeShadowId}
          x="-25%"
          y="-25%"
          width="150%"
          height="160%"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.2" result="blur" />
          <feOffset dy="1.7" result="offset" />
          <feFlood floodColor="#000716" floodOpacity="0.9" result="shadowColor" />
          <feComposite in="shadowColor" in2="offset" operator="in" result="shadow" />
          <feMerge>
            <feMergeNode in="shadow" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      <g filter={`url(#${ringShadowId})`}>
        <path
          d="M139.4 248A94.6 94.6 0 1 1 269.6 249.1"
          fill="none"
          stroke="#aeb7c4"
          strokeWidth="10.5"
          strokeLinecap="round"
        />
        <path
          d="M139.4 248A94.6 94.6 0 1 1 269.6 249.1"
          fill="none"
          stroke={`url(#${ringGradientId})`}
          strokeWidth="7.2"
          strokeLinecap="round"
        />
      </g>

      <g filter={`url(#${planeShadowId})`} strokeLinejoin="round">
        <path
          d="M138.3 195.8 244.5 137.8 194.7 195.9Z"
          fill={`url(#${wingGradientId})`}
          stroke="#7d95ae"
          strokeWidth="0.9"
        />
        <path
          d="M138.3 195.8 194.7 195.9 190.8 191.9Z"
          fill={`url(#${wingShadeId})`}
        />
        <path
          d="M244.5 137.8 194.7 195.9 213.7 251.8Z"
          fill={`url(#${bladeGradientId})`}
          stroke="#d7dce3"
          strokeWidth="0.9"
        />
      </g>
    </svg>
  )
}

type BrandProps = {
  className?: string
  href?: string
}

export function Brand({ className = '', href = '/#top' }: BrandProps) {
  return (
    <a
      className={`brand ${className}`.trim()}
      href={href}
      aria-label="Ark Solutions home"
    >
      <BrandMark />
      <span>Ark Solutions</span>
    </a>
  )
}
